import React from 'react';
import PropTypes from 'prop-types';

import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';

const myBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const MySlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.secondary.main,
  '& .MuiSlider-thumb': {
    height: 15,
    width: 15,
    backgroundColor: theme.palette.grayscale.light,
    border: `1px solid ${theme.palette.grayscale.main}`,
    boxShadow: myBoxShadow,
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: myBoxShadow,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: myBoxShadow,
      },
    },
  },
  '& .MuiSlider-mark': {
    backgroundColor: theme.palette.grayscale.main,
    height: 15,
    width: 1,
  },
  '& .MuiSlider-markLabel': {},

  '& .MuiSlider-rail': {
    backgroundColor: theme.palette.grayscale.main,
  },
}));

const marks = [
  {
    value: 0,
  },
  {
    value: 1,
  },
  {
    value: 2,
  },
  {
    value: 3,
  },
  {
    value: 4,
  },
  {
    value: 5,
  },
];

const FilterableSlider = ({ item, onRangeChange }) => {
  const minDistance = 1;
  const [sliderVal, setSliderVal] = React.useState(item.filters);


  const handleSliderChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    let nv = [];
    if (activeThumb === 0) {
      nv[0] = Math.min(newValue[0], newValue[1] - minDistance);
      nv[1] = newValue[1];
    } else {
      nv[0] = newValue[0];
      nv[1] = Math.max(newValue[1], newValue[0] + minDistance);
    }
    item.filters = nv;
    setSliderVal(nv);
    onRangeChange(item);
  };

  return (
    <MySlider
      getAriaLabel={() => 'HVRA Category Range'}
      onChange={handleSliderChange}
      value={sliderVal}
      marks={marks}
      min={0}
      max={5}
      valueLabelDisplay="off"
      disableSwap={true}
      disabled={item.exclude}
    />
  );

};

FilterableSlider.displayName = 'FilterableSlider';
FilterableSlider.propTypes = {
  item: PropTypes.object.isRequired,
  onRangeChange: PropTypes.func.isRequired
};

export default FilterableSlider;
